import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import { i18n, loadLanguageAsync } from '@/i18n';
import { store } from '@/store';
import { scrollBehavior } from '@cnamts/vue-dot/src/helpers/scrollBehavior';
import { routes } from './routes';
import { routesSspa } from './routesSspa';
import {
	handleNotificationFromQuery,
	handleMaintenanceMode,
	handleAuthentication
} from './guards';

declare const QRP_MAINTENANCE: string;

Vue.use(VueRouter);
Vue.use(VueMeta, {
	refreshOnceOnNavigation: true
});

const router = new VueRouter({
	mode: 'history',
	routes,
	scrollBehavior
});

router.afterEach((to) => {
	handleNotificationFromQuery(to.query.notification as string | undefined);
});

router.beforeEach(async(to, from, next) => {
	try {
		await store.dispatch('notification/clearNotification');

		await loadLanguageAsync(i18n.locale);

		const maintenanceResult = handleMaintenanceMode(to, QRP_MAINTENANCE === 'true');
		if (maintenanceResult) {
			next(maintenanceResult);
			return;
		}

		await handleAuthentication(to, next);
	} catch (error) {
		next(false);
	}
});

export { router };

const routerSspa = new VueRouter({
	mode: 'history',
	routes: routesSspa,
	scrollBehavior
});

routerSspa.beforeEach(async(to, from, next) => {
	try {
		await store.dispatch('notification/clearNotification');
		await loadLanguageAsync(i18n.locale);
		await handleAuthentication(to, next);
	} catch {
		next(false);
	}
});

export { routerSspa };
